import reducer, { initialState, OptionsContextActions, OptionsContextState } from './reducer';
import React, { createContext, Dispatch, useCallback, useMemo, useReducer } from 'react';
import useAbortableEffect from '../hooks/useAbortableEffect';
import { FCWithChildren } from '../utils/utils.types';
import { getAllCurrencies } from '@round/api';

type OptionsContextValues = OptionsContextState;

export const OptionsContext = createContext<OptionsContextValues | null>(null);
export const OptionsDispatchContext = createContext<Dispatch<OptionsContextActions> | null>(null);
export const OptionsProvider: FCWithChildren = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const apexCurrencyOptionNames = useMemo(() => ['USD', 'EUR', 'GBP', 'COP'], []);

    const fetchCurrencies = useCallback(
        async (requestInit?: RequestInit) => {
            try {
                getAllCurrencies(undefined, requestInit).then((currencies) => {
                    const apexCurrencies = currencies.filter((curr) => apexCurrencyOptionNames.includes(curr.name));
                    dispatch({ type: 'currenciesLoaded', payload: apexCurrencies });
                });
            } catch {
                // no-op
            }
        },
        [apexCurrencyOptionNames]
    );

    useAbortableEffect(
        (signal) => {
            fetchCurrencies({ signal });
        },
        [fetchCurrencies]
    );

    return (
        <OptionsContext.Provider value={state}>
            <OptionsDispatchContext.Provider value={dispatch}>{children}</OptionsDispatchContext.Provider>
        </OptionsContext.Provider>
    );
};
